"use strict";

var LoggerInstance = require("js-logger").get("OneTimePasswordApi");

var AbstractApi = require("./AbstractApi");

var ApiHelper = require("../shared/ApiHelper");

var OneTimePasswordApi = class extends AbstractApi {
	//Call made to SO API
	getOneTimePasswordHtml(themeId) {
		if (!themeId) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `ThemeId was not specified: ${themeId}.`);
		}

		return this.get({
			url: "/api/onetimepassword",
			queryString: {
				themeId
			}
		});
	}

	//Call made to SO API
	generateOneTimePassword(options) {
		options = options || {};

		if (!options.email) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `Email Not Provided: ${options.email}.`);
		}

		return this.post({
			url: "/api/onetimepassword/generate",
			data: {
				emailAddress: options.email
			}
		});
	}

	//Call made to SO API
	verifyOneTimePassword(options) {
		options = options || {};

		if (!options.oneTimePassword) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `One Time Password Not Provided: ${options.oneTimePassword}.`);
		}

		return this.post({
			url: "/api/onetimepassword/verify",
			data: {
				verificationCode: options.oneTimePassword
			}
		});
	}
};

module.exports = new OneTimePasswordApi();
